import { Link as RouterLink } from "react-router-dom";
import {
  Grid,
  Box,
  Link,
  Divider,
  Container,
  Typography,
  IconButton,
  Stack,
  Button,
  InputBase,
} from "@mui/material";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";
import YouTubeIcon from "@mui/icons-material/YouTube";
// routes
// import { PATH_AUTH, PATH_DASHBOARD } from "src/routes/paths";
import { BlackLogo, YellowLogo } from "src/components/Logo.jsx";

const SOCIALS = [
  {
    name: "FaceBook",
    icon: <FacebookOutlinedIcon />,
    link: "https://facebook.com",
  },
  { name: "Instagram", icon: <InstagramIcon />, link: "https://instagram.com" },
  { name: "Twitter", icon: <TwitterIcon />, link: "https://twitter.com" },
  { name: "YouTube", icon: <YouTubeIcon />, link: "https://youtube.com" },
];

const LINKS = [
  {
    headline: "Product",
    children: [
      { name: "Features", href: "#" },
      { name: "Pricing", href: "#" },
      { name: "Case studies", href: "#" },
      { name: "Reviews", href: "#" },
      { name: "Updates", href: "#" },
    ],
  },
  {
    headline: "Company",
    children: [
      { name: "About", href: "#" },
      { name: "Contact us", href: "#" },
      { name: "Careers", href: "#" },
      { name: "Culture", href: "#" },
      { name: "Blog", href: "#" },
    ],
  },
  {
    headline: "Support",
    children: [
      { name: "Getting started", href: "#" },
      { name: "Help center", href: "#" },
      { name: "Server status", href: "#" },
      { name: "Report a bug", href: "#" },
      { name: "Chat support", href: "#" },
    ],
  },
  {
    headline: "Downloads",
    children: [
      { name: "iOS", href: "#" },
      { name: "Android", href: "#" },
      { name: "Mac", href: "#" },
      { name: "Windows", href: "#" },
      { name: "Chrome", href: "#" },
    ],
  },
];

export default function MainFooter({ isDark = false }) {
  return (
    <Box sx={{ bgcolor: isDark ? "common.black" : "common.white" }}>
      <Container maxWidth="xl" sx={{ py: { xs: 3, md: 10 } }}>
        <Grid
          container
          spacing={3}
          justifyContent={{ xs: "center", md: "space-between" }}
          mb={{ xs: 4, md: 10 }}
        >
          <Grid item xs={12} md={3} sx={{ mb: 3 }}>
            <Stack direction={{ xs: "row", md: "column" }} spacing={2}>
              {isDark ? (
                <YellowLogo
                  sx={{
                    mx: { xs: "auto", md: "inherit" },
                    width: { xs: 100, md: 150 },
                    height: { xs: 90, md: 140 },
                  }}
                />
              ) : (
                <BlackLogo
                  sx={{
                    mx: { xs: "auto", md: "inherit" },
                    width: { xs: 100, md: 150 },
                    height: { xs: 90, md: 140 },
                  }}
                />
              )}
              <Typography
                color={isDark ? "text.primary" : "text.secondary"}
                variant="subtitle1"
                sx={{ pr: { md: 5 }, fontWeight: 500 }}
              >
                No. 14 Dade Close, Cantonment, Accra, GHANA email:
                support@afrikast.com Call us: (+233) 33 842 05 05
              </Typography>
            </Stack>
          </Grid>

          <Grid container item xs={12} md={6} columnSpacing={2} rowSpacing={4}>
            {LINKS.map((list) => {
              const { headline, children } = list;
              return (
                <Grid
                  item
                  xs={6}
                  md={3}
                  key={headline}
                  sx={{ display: "flex", justifyContent: "center" }}
                >
                  <Stack spacing={2}>
                    <Typography
                      variant="h6"
                      color={isDark ? "text.primary" : "text.secondary"}
                    >
                      {headline}
                    </Typography>
                    {children.map((link) => (
                      <Link
                        to={link.href}
                        key={link.name}
                        color="grey.700"
                        variant="body2"
                        component={RouterLink}
                        sx={{
                          display: "block",
                          textDecoration: "none",
                          "&:hover": {
                            textDecoration: "underline",
                          },
                        }}
                      >
                        {link.name}
                      </Link>
                    ))}
                  </Stack>
                </Grid>
              );
            })}
          </Grid>

          <Grid item xs={12} md={3}>
            <Stack spacing={2} sx={{ px: 3 }}>
              <Typography
                variant="h6"
                color={isDark ? "text.primary" : "text.secondary"}
              >
                Subscribe to our newsletter
              </Typography>
              <Typography
                color="grey.700"
                variant="body2"
                sx={{
                  display: "block",
                }}
              >
                Lorem ipsum dolor sit amet consectetur adipiscing elit aliquam
                mauris sed ma
              </Typography>
              <InputBase
                placeholder="Enter your email"
                sx={{
                  color: "grey.700",
                  fontSize: 18,
                  px: 2,
                  py: 1,
                  border: "1px solid #D9DBE9",
                  boxShadow: "0px 2px 12px rgba(20, 20, 43, 0.08)",
                  borderRadius: "100px",
                }}
              />
              <Box display="flex">
                <Button
                  color={isDark ? "inherit" : "secondary"}
                  variant="contained"
                  sx={{ borderRadius: "75px", fontSize: 16 }}
                >
                  Subscribe
                </Button>
              </Box>
            </Stack>
            <Stack
              spacing={1.5}
              direction="row"
              sx={{ mt: 5, mb: { xs: 5, md: 0 }, px: 3 }}
            >
              {SOCIALS.map((social) => (
                <IconButton
                  key={social.name}
                  color={isDark ? "inherit" : "secondary"}
                  sx={{ p: 1 }}
                >
                  {social.icon}
                </IconButton>
              ))}
            </Stack>
          </Grid>
        </Grid>
        <Divider />
      </Container>
    </Box>
  );
}
